import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { TextField, MenuItem, Select, Checkbox, FormControl, RadioGroup, Radio, FormControlLabel, Autocomplete } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { ExpandMore } from "@mui/icons-material";
import { useFetchGetAllProjectBasedUserNameListQuery, useFetchTaskListsQuery, useFetchUserAccessedProjectsQuery } from "../../../slice/logdetailSlice";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { postdatas, postResource } from "../../../apis/apiService";
import { BtnLoader } from "../Loader";
import QuillComponent from "../ReactQuill";
import { parseDate, validateEndDate, validateStartDate } from "../PreventValidate";


export const CommonAddTaskTab = ({
  onApply,
  onClear,
  onCancel,
  refetchList,
  isModule,
  path_1,
  path_2,
  isSubtaskList,
  isMilestone,
  editData,
}) => {
  const isEdit = !!editData;
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user_detail in redux state: ", loginUser);
  const { id: login_user_id } = loginUser;

  // const { id } = useParams();
    const { id, project_id: url_project_id } = useParams();
    
  const { task_list_id } = useParams();
  const numericId = id?.match(/\d+/)?.[0];

  // const project_id = localStorage.getItem("project_id");
  // const project_id = url_project_id || id || localStorage.getItem("project_id");
  // const raw_project_id = url_project_id || localStorage.getItem("project_id") || id;

  // Prefer localStorage (reliably set by ProjectDetail) over route `id` param
  // but ONLY when not in global Task module mode (isModule).
  const raw_project_id = url_project_id || (!isModule ? localStorage.getItem("project_id") : null) || id;

  const project_id = raw_project_id ? parseInt(String(raw_project_id).replace(/\D/g, ""), 10) || raw_project_id : null;

  const [selectedProject, setSelectedProject] = useState(
    // isModule ? null : project_id
     (isModule && !isEdit) ? null : project_id
  );
  const { data: user_accessed_project  , refetch : user_accessed_project_refetch} = useFetchUserAccessedProjectsQuery();
  // const login_user_id = id;
  // const login_user_name = name;
  //console.log("login_user_detail :id", login_user_id);

  const { data: tasklist } = useFetchTaskListsQuery(selectedProject,{skip : !selectedProject});
  //console.log("task_list after adding list: ", tasklist);
  const priorityList = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  const priorityOptions = priorityList?.find((list) => list?.priority_type === "TASK");
  useSelector((state) => state.selectOptions?.tasklistdatas);
  //console.log("taskListOptions : ", TaskListOptions);
  const { data: usersInProjects } = useFetchGetAllProjectBasedUserNameListQuery(selectedProject,{skip : !selectedProject});
  //console.log("users_in_projects usersInProjects project :", usersInProjects);
  const [selectedUser, setSelectedUser] = useState("");
  const StatusOptions = useSelector((state) => state.selectOptions?.StatusOptions);
  const statusNames = StatusOptions?.find((status) => status.status_type === "TASK");
  const status_list = statusNames?.status_details?.map((status) => ({
    status_id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      project_id: "",
      TaskName: "",
      startDate: null,
      endDate: null,
      defaultDescription: "",
      owners: [login_user_id] || [],
      billingType: "BILLABLE",
      // TaskName: "",
      WorkHours: "",
      Priority: "",
      uploadedFile: null,
      Followers: "",
      TaskList: "",
      current_status_id: "",
    },
  });

  const openStatusId = useMemo(() => {
    return status_list?.find((s) => (s.status_name || "").toUpperCase() === "OPEN")
      ?.status_id;
  }, [status_list]);

  useEffect(() => {
    if (usersInProjects && login_user_id) {
      const matchingUser = usersInProjects.find(
        (user) => user.user_id === login_user_id
      );
      //console.log("login_user_detail matching value :", matchingUser);

      if (matchingUser) {
        setSelectedUser(matchingUser.user_id); // Set the default value
        // When isModule and project is freshly selected, ensure owner field has current user
        if (!isEdit) {
          const currentOwners = getValues("owners");
          if (!currentOwners || currentOwners.length === 0) {
            setValue("owners", [login_user_id]);
          }
        }
      }
    }
  }, [usersInProjects, login_user_id]);
  // const handleChange = (e) => {
  //   setSelectedUser(e.target.value);
  // };

  const [uploadedFile, setUploadedFile] = useState(null);

  useEffect(() => {
    if (isEdit && editData) {
      reset({
        // project_id: editData.project_id || project_id,
        // TaskName: editData.title || "",
        // startDate: editData.start_date ? dayjs(editData.start_date, "DD/MM/YYYY") : null,
        // endDate: editData.end_date ? dayjs(editData.end_date, "DD/MM/YYYY") : null,
        project_id: editData.project_id || project_id,
        TaskName: editData.title || "",
        // startDate: editData.start_date ? (dayjs(editData.start_date, "DD/MM/YYYY").isValid() ? dayjs(editData.start_date, "DD/MM/YYYY") : dayjs(editData.start_date)) : null,
        // endDate: editData.end_date ? (dayjs(editData.end_date, "DD/MM/YYYY").isValid() ? dayjs(editData.end_date, "DD/MM/YYYY") : dayjs(editData.end_date)) : null,
        startDate: parseDate(editData.start_date),
        endDate: parseDate(editData.end_date),
        defaultDescription: editData.description || "",
        // owner: editData.owners?.map((u) => u.user_id) || [],
        owners: editData.owners?.map((u) => u.user_id) || [],
        billingType: editData.billing_type || "BILLABLE",
        WorkHours: editData.estimated_hours || "",
        Priority: editData.priority_id || "",
        Followers: editData.followers || "",
        TaskList: editData.task_list_id || "",
        current_status_id: editData.current_status_id || "",
      });
      if (editData.project_id) {
        setSelectedProject(editData.project_id);
      }
    } 
    else {
      reset({
        // project_id: project_id || "",
        project_id: (isModule && !isEdit) ? "" : (project_id || ""),
        TaskName: "",
        startDate: null,
        endDate: null,
        defaultDescription: "",
        // owner: [login_user_id] || [],
        owners: [login_user_id] || [],
        billingType: "BILLABLE",
        WorkHours: "",
        Priority: "",
        uploadedFile: null,
        Followers: "",
        TaskList: "",
        // current_status_id: "",
        current_status_id: openStatusId || "",
      });
    }
    // }, [editData, isEdit, reset, project_id, login_user_id]);
  }, [editData, isEdit, reset, project_id, login_user_id, openStatusId]);

  const addMoreTasks = (e) => {
    e.preventDefault();
    handleSubmit((data) => addMoreTasksApi(data))();
  };
  const addMoreTasksApi = async (data) => {
    const finalData = { ...data, uploadedFile };
    if (finalData.startDate && finalData.endDate && !validateEndDate(finalData.startDate, finalData.endDate)) {
      return;
    }
    const requestData = {
      title: finalData.TaskName,
      // project_id: finalData.project_id,
      project_id: finalData.project_id ? parseInt(String(finalData.project_id).replace(/\D/g, ""), 10) || finalData.project_id : null,
      start_date: finalData.startDate
        // ? format(new Date(finalData.startDate), "dd-MM-yyyy")
        ? dayjs(finalData.startDate).format("DD-MM-YYYY")
        : null,
      end_date: finalData.endDate
        // ? format(new Date(finalData.endDate), "dd-MM-yyyy")
        ? dayjs(finalData.endDate).format("DD-MM-YYYY")
        : null,
      description: finalData.defaultDescription,
      followers: finalData.Followers,
      estimated_hours: finalData.WorkHours,
      priority_id: finalData.Priority,
      // owner: finalData.owner,
      // owners: finalData.owners,
      owners: (finalData.owners || []).filter(id => id !== null && id !== "").map(id => parseInt(id, 10)).filter(id => !isNaN(id)),
      owner: (finalData.owners || []).filter(id => id !== null && id !== "").map(id => parseInt(id, 10)).filter(id => !isNaN(id)),
      billing_type: finalData.billingType,
      document: finalData.uploadedFile,
      task_list_id: !isSubtaskList ? finalData.TaskList : numericId,
      // current_status_id: finalData.current_status_id || null, // Pazhaya code
      current_status_id: finalData.current_status_id || null,
      status_id: finalData.current_status_id || null, // Puthusa add panniyathu (add aagumbothu status set aga)
    };
    if (!isSubtaskList) {
      requestData.task_list_id = finalData.TaskList;
    }
    setIsSubmitting(true);
    try {
      // Call the API to create the entity
      // if (isSubtaskList) {
      //   const response = await postResource(
      //     path_1,
      //     path_2,
      //     numericId,
      //     requestData
      //   );
      // }
      let response;

      // if (isSubtaskList) {
      if (isEdit) {
        response = await postResource("task", "update",editData.task_id || editData.id, requestData);
      } 
      else if (isSubtaskList) {
        response = await postResource(
          path_1,
          path_2,
          !isMilestone ? numericId : task_list_id,
          requestData
        );
      } else {
        response = await postdatas(path_1, path_2, requestData);
      }

      // HACK: API forces task to Open on creation. If user selected a specific status, update it immediately.
      if (!isEdit && !isSubtaskList && finalData.current_status_id && response && response.data) {
        const d = response.data;
        const newId = d.task_id || d.id || (d.data && (d.data.task_id || d.data.id));
        if (newId) {
          try {
            await postResource("task", "update", newId, {
              current_status_id: finalData.current_status_id,
              owners: finalData.owners,
              followers: finalData.Followers,
              task_id: newId
            });
          } catch (e) { console.error("Auto status update failed", e); }
        }
      }

      // const response = await postdatas(path_1, path_2, requestData);
      // toast.success("Task Added Successfully");
      toast.success(isEdit ? "Task Updated Successfully" : "Task Added Successfully");
      //console.log("selected_user :", selectedUser);

      // onApply(response.data)
      reset();
      // onCancel();
      if (refetchList) {
        refetchList();
      }
      if (isEdit && onCancel) {
        onCancel();
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    user_accessed_project_refetch();
  }, [selectedProject]);

  const onSubmit = async (data) => {
    //console.log("selected_user  data ===:", data);
    const finalData = { ...data, uploadedFile };
    if (finalData.startDate && finalData.endDate && !validateEndDate(finalData.startDate, finalData.endDate)) {
      return;
    }

    const requestData = {
      title: finalData.TaskName,
      // project_id: finalData.project_id,
      project_id: finalData.project_id ? parseInt(String(finalData.project_id).replace(/\D/g, ""), 10) || finalData.project_id : null,
      start_date: finalData.startDate ? dayjs(finalData.startDate).format("DD-MM-YYYY") : null,
      end_date: finalData.endDate
        // ? format(new Date(finalData.endDate), "dd-MM-yyyy")
        ? dayjs(finalData.endDate).format("DD-MM-YYYY")
        : null,
      description: finalData.defaultDescription,
      followers: finalData.Followers,
      estimated_hours: finalData.WorkHours,
      priority_id: finalData.Priority,
      // owner: finalData.owner,
      // owners: finalData.owners, // pass owners id to get response
      // owner: finalData.owners, // Send as array to satisfy backend validation
      owners: (finalData.owners || []).filter(id => id !== null && id !== "").map(id => parseInt(id, 10)).filter(id => !isNaN(id)), // pass owners id to get response
      owner: (finalData.owners || []).filter(id => id !== null && id !== "").map(id => parseInt(id, 10)).filter(id => !isNaN(id)), // Send as array to satisfy backend validation
      billing_type: finalData.billingType,
      document: finalData.uploadedFile,
      // task_list_id: finalData.TaskList,
      task_list_id: !isSubtaskList ? finalData.TaskList : numericId,
      // current_status_id: finalData.current_status_id || null, // Pazhaya code
      current_status_id: finalData.current_status_id || null,
      status_id: finalData.current_status_id || null,  // Puthusa add panniyathu (add aagumbothu status set aga)
    };
    //console.log("task_request_data", requestData);

    if (!isSubtaskList) {
      requestData.task_list_id = finalData.TaskList;
    }
    setIsSubmitting(true);

    try {
      // Call the API to create the entity
      // if (isSubtaskList) {
      //   const response = await postResource(
      //     path_1,
      //     path_2,
      //     numericId,
      //     requestData
      //   );
      // }
      let response;

      // if (isSubtaskList) {
      if (isEdit) {
        response = await postResource("task", "update", editData.task_id || editData.id, requestData);
      } 
      else if (isSubtaskList) {
        response = await postResource(
          path_1,
          path_2,
          !isMilestone ? numericId : task_list_id,
          requestData
        );
      } 
      else {
        response = await postdatas(path_1, path_2, requestData);
      }

      // HACK: API forces task to Open on creation. If user selected a specific status, update it immediately.
      if (!isEdit && !isSubtaskList && finalData.current_status_id && response && response.data) {
        const d = response.data;
        const newId = d.task_id || d.id || (d.data && (d.data.task_id || d.data.id));
        if (newId) {
          try {
            await postResource("task", "update", newId, {
              current_status_id: finalData.current_status_id,
              owners: finalData.owners,
              followers: finalData.Followers,
              task_id: newId
            });
          } catch (e) { console.error("Auto status update failed", e); }
        }
      }

      // const response = await postdatas(path_1, path_2, requestData);
      // toast.success("Task Added Successfully");
      //console.log("selected_user :", selectedUser);
      toast.success(isEdit ? "Task Updated Successfully" : "Task Added Successfully");

      // onApply(response.data)
      reset();
      onCancel();
      if (refetchList) {
        refetchList();
      }
    } 
    catch (error) {
      toast.error(error.message);
    } 
    finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="">
      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">

        <button onClick={onCancel} className="R_btn">
          <div className="d-flex text-rgba-gray align-items-center">
            <IoIosArrowBack />
            {/* Add Task */}
            {isEdit ? "Edit Task" : "Add Task"}
          </div>
        </button>
      </div>

      <div className="bg-white overflow-scroll pb-5 pt-3 px-4">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row mb-3">
                {isModule && (
                  <div className="col-md-12">
                    <label htmlFor="project_id" className="form-label">
                      Project name <span className="errorMsg">*</span>
                    </label>
                    <Controller
                      name="project_id"
                      control={control}
                      rules={{ required: "Project field is required" }}
                      render={({
                        field: { onChange, value },
                        formState: { errors },
                      }) => (
                        <>
                          <Autocomplete
                            id="project_id"
                            popupIcon={<ExpandMore />}
                            options={
                              Array.isArray(user_accessed_project)
                                ? user_accessed_project
                                : []
                            }
                            getOptionLabel={(option) => option.title}
                            value={
                              user_accessed_project?.find(
                                (user) => user.project_id === value
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                if (Array.isArray(newValue)) {
                                  toast.error(
                                    "You can select only one project."
                                  );
                                } else {
                                  onChange(newValue.project_id);
                                  setSelectedProject(newValue.project_id); // Set selected user ID
                                }
                              } else {
                                onChange(null);
                                setSelectedProject(null); // Reset selected user ID
                              }
                            }}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <strong>{option.title}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select project"
                              />
                            )}
                          />
                          <span className="errorMsg">
                            {errors?.project_id?.message}
                          </span>
                        </>
                      )}
                    />
                  </div>
                )}
              </div>
              
              {selectedProject && (
                <>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="TaskName" className="form-label">
                        Task Title<span className="text-rgbr-red"> *</span>
                      </label>
                      <TextField
                        id="TaskName"
                        placeholder="Enter Task Title"
                        fullWidth
                        variant="outlined"
                        {...register("TaskName", {
                          required: "Task Title is required",
                        })} // Add validation rule here
                      />
                      {errors.TaskName && (
                        <span className="errorMsg">
                          {errors.TaskName.message}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <QuillComponent
                        control={control}
                        name="defaultDescription"
                        label="Description"
                      />
                    </div>
                  </div>

                  {/* <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="Upload File" className="form-label">
                    Upload File
                  </label>
                  <FileUpload onFileChange={(file) => setUploadedFile(file)} />
                </div>
              </div> */}

                  <div className="row mb-3">
                    {!isSubtaskList && (
                      <div className="col-md-12">
                        <label htmlFor="TaskList" className="form-label">
                          Task List <span className="errorMsg">*</span>
                        </label>

                        <Controller
                          name="TaskList"
                          control={control}
                          rules={{ required: "Task List field is required" }}
                          defaultValue={null} // Default to null (no selection)
                          render={({
                            field: { ref, onChange, value },
                            fieldState: { error },
                          }) => (
                            <FormControl fullWidth>
                              <Select
                                inputRef={ref}
                                onChange={onChange}
                                labelId="tasklist-label"
                                id="tasklist"
                                IconComponent={ExpandMoreIcon}
                                // {...field}
                                value={value}
                                displayEmpty
                                renderValue={(selected) =>
                                  selected ? (
                                    tasklist?.find(
                                      (list) => list.task_list_id === selected
                                    )?.task_list_name
                                  ) : (
                                    <span className="lightText">TaskList</span>
                                  )
                                }
                              >
                                {tasklist?.length === 0 && (
                                  <MenuItem key="0" value="">
                                    <em>No Task Lists</em>
                                  </MenuItem>
                                )}

                                {tasklist?.map((tasklist, index) => (
                                  <MenuItem
                                    key={index}
                                    value={tasklist.task_list_id}
                                  >
                                    {tasklist.task_list_name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {error && (
                                <span className="errorMsg">
                                  {error.message}
                                </span>
                              )}
                            </FormControl>
                          )}
                        />
                      </div>
                    )}

                    <div className="col-md-12 mt-3">
                      {/* <label htmlFor="owner" className="form-label"> */}
                      <label htmlFor="owners" className="form-label">
                        Owner
                        {/* <span className="errorMsg">*</span> */}
                      </label>
                      {/* <FormControl fullWidth>
                        <Select
                          labelId="owner-label"
                          id="owner"
                          {...control.register("owner")}
                          IconComponent={ExpandMore}
                          displayEmpty
                          value={selectedUser}
                          onChange={handleChange}
                          renderValue={(selected) => {
                            if (!selected) {
                              return <span className="lightText">Owner</span>;
                            }
                            const selectedUserObj = usersInProjects?.find(
                              (user) => user.user_id === selected
                            );
                            return selectedUserObj ? (
                              selectedUserObj.user_id === login_user_id ? (
                                `${selectedUserObj.name} (You)`
                              ) : (
                                selectedUserObj.name
                              )
                            ) : (
                              <span className="lightText">Owner</span>
                            );
                          }}
                        >
                          {usersInProjects?.map((userlist, index) => {
                            if (userlist.user_id === login_user_id) {
                              //console.log(
                                "login_user_detail user ids are same...😇"
                              );
                            }
                            return (
                              <MenuItem
                                index={index}
                                defaultValue={
                                  userlist.user_id === login_user_id
                                }
                                value={userlist.user_id}
                              >
                                {userlist.user_id === login_user_id
                                  ? `${userlist.name} (You)`
                                  : userlist.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl> */}

                      <Controller
                        // name="owner"
                        name="owners"
                        control={control}
                        // defaultValue={[]}
                        // rules={{ required: "Owner is required" }}
                        render={({
                          field: { onChange, value = [] },
                          fieldState: { error },
                        }) => (
                          <>
                            <Autocomplete
                              multiple
                              // id="owner"
                              id="owners"
                              popupIcon={<ExpandMore />}
                              options={usersInProjects || []}
                              disableCloseOnSelect
                              getOptionLabel={(option) => option?.name || ""}
                              value={
                                Array.isArray(value)
                                  ? value
                                    .map((user_id) =>
                                      (usersInProjects || [])?.find(
                                        (user) => user.user_id === user_id
                                      )
                                    )
                                    .filter(Boolean) // ✅ Remove undefined values
                                  : []
                              }
                              onChange={(event, newValue) => {
                                const selectedTitles = newValue.map(
                                  (user) => user.user_id
                                );
                                onChange(selectedTitles);
                              }}
                              renderOption={(props, option, { selected }) => (
                                <li
                                  {...props}
                                  className="d-flex align-items-center mb-2"
                                >
                                  <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                  />
                                  <strong>{option.name}</strong>
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField {...params} placeholder="Owner" />
                              )}
                              ListboxProps={{
                                style: {
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: "8px",
                                  paddingLeft: "0",
                                },
                              }}
                            />

                            {/* <span className="errorMsg">
                              {errors?.owner?.message}
                            </span> */}
                          </>
                        )}
                      />
                    </div>

                    {/* followers */}
                    {/* <div className="col-md-12 mt-3">
                      <label htmlFor="Followers" className="form-label">
                        Add Followers
                      </label>
                      <Controller
                        name="Followers"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Autocomplete
                            multiple
                            id="Followers"
                            options={usersInProjects}
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.name}
                            value={
                              (value || []).map((user_id) =>
                                usersInProjects?.find(
                                  (user) => user.user_id === user_id
                                )
                              ) || []
                            }
                            onChange={(event, newValue) => {
                              const selectedTitles = newValue.map(
                                (user) => user.user_id
                              );
                              onChange(selectedTitles);
                            }}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <strong>{option.name}</strong>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField {...params} placeholder="Followers" />
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                          />
                        )}
                      />
                    </div> */}
                  </div>
                  
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="startDate" className="form-label">
                        Start Date
                      </label>
                      <div className=" d-flex  flex-column w-100 ">
                        <Controller
                          name="startDate"
                          control={control}
                          rules={{
                            validate: (val) => {
                              if (!val) return true;
                              const d = dayjs(val);
                              if (!d.isValid()) return "Invalid date format";
                              if (d.year() < 1990) return "Invalid date format";
                              return true;
                            }
                          }}
                          render={({ field }) => (
                            <>
                              <DatePicker
                                {...field}
                                // onChange={(date) => field.onChange(date)}
                                  onChange={(date) => {
                                  const endDate = getValues("endDate");
                                   if (date && endDate && !validateStartDate(date, endDate)) {
                                     const current = getValues("startDate");
                                     setValue("startDate", null);
                                     setTimeout(() => setValue("startDate", current), 0);
                                     return;
                                   }
                                  field.onChange(date);
                                }}
                                format="DD/MM/YYYY"
                                renderInput={(params) => (
                                  <input className="form-control" {...params} />
                                )}
                              />
                              {errors.startDate && (
                                <span className="errorMsg">
                                  {errors.startDate.message}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="endDate" className="form-label">
                        End Date
                      </label>
                      <div className=" d-flex  flex-column w-100 ">
                        <Controller
                          name="endDate"
                          control={control}
                          rules={{
                            validate: (val) => {
                              if (!val) return true;
                              const d = dayjs(val);
                              if (!d.isValid()) return "Invalid date format";
                              if (d.year() < 1990) return "Invalid date format";
                              return true;
                            }
                          }}
                          render={({ field }) => (
                            <>
                              <DatePicker
                                {...field}
                                // onChange={(date) => field.onChange(date)}
                                  onChange={(date) => {
                                  const startDate = getValues("startDate");
                                   if (date && startDate && !validateEndDate(startDate, date)) {
                                     const current = getValues("endDate");
                                     setValue("endDate", null);
                                     setTimeout(() => setValue("endDate", current), 0);
                                     return;
                                   }
                                  field.onChange(date);
                                }}
                                format="DD/MM/YYYY"
                                renderInput={(params) => (
                                  <input className="form-control" {...params} />
                                )}
                              />
                              {errors.endDate && (
                                <span className="errorMsg">
                                  {errors.endDate.message}
                                </span>
                              )}
                            </>
                          )}
                        />
                      </div>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="WorkHours" className="form-label">
                        Estimated Hours
                      </label>
                      <TextField
                        type="number"
                        id="WorkHours"
                        placeholder="Enter Work Hours"
                        className="form-control"
                        {...control.register("WorkHours")}
                        inputProps={{ min: 0 }}
                      />
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="current_status_id" className="form-label">
                        Status
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="current_status_id"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              displayEmpty
                              renderValue={(selected) => {
                                const selectedStat = status_list?.find(
                                  (s) => s.status_id === selected
                                );
                                return selectedStat ? (
                                  <span style={{ color: selectedStat.status_colour }}>
                                    {selectedStat.status_name}
                                  </span>
                                ) : (
                                  <span className="lightText">Select status</span>
                                );
                              }}
                              IconComponent={ExpandMoreIcon}
                            >
                              {status_list?.map((s) => (
                                <MenuItem
                                  key={s.status_id}
                                  value={s.status_id}
                                  sx={{ color: s.status_colour || "black" }}
                                >
                                  {s.status_name}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                      </FormControl>
                    </div>

                    <div className="col-md-6 mt-3">
                      <label htmlFor="Priority" className="form-label">
                        Priority
                        {/* <span className="errorMsg">*</span> */}
                      </label>
                      <FormControl fullWidth>
                        <Controller
                          name="Priority"
                          control={control}
                          // rules={{ required: "Priority field is required" }}
                          render={({
                            field: { onChange, value, ref },
                            fieldState: { error },
                          }) => (
                            <>
                              <Select
                                onChange={onChange}
                                inputRef={ref}
                                value={value}
                                displayEmpty
                                renderValue={(selected) => {
                                  const selected_value =
                                    priorityOptions?.priority_details?.find(
                                      (list) => list.priority_id === selected
                                    );
                                  return selected_value ? (
                                    <span
                                      style={{
                                        color:
                                          selected_value.priority_colour ||
                                          "black",
                                      }}
                                    >
                                      {selected_value.priority_name}
                                    </span>
                                  ) : (
                                    <span className="lightText">
                                      Select priority
                                    </span>
                                  );
                                }}
                                IconComponent={ExpandMoreIcon}
                              >
                                {priorityOptions?.priority_details.map(
                                  (priority) => (
                                    <MenuItem
                                      key={priority?.priority_id}
                                      // color={priority?.priority_color}
                                      sx={{
                                        color:
                                          priority?.priority_colour || "black",
                                      }}
                                      value={priority?.priority_id}
                                    >
                                      {priority?.priority_name}
                                    </MenuItem>
                                  )
                                )}
                              </Select>
                              {/* {error && (
                                <span className="errorMsg">
                                  {error.message}
                                </span>
                              )} */}
                            </>
                          )}
                        />
                      </FormControl>
                    </div>

                    <div className="col-md-12 d-flex align-items-center mt-3" style={{ marginBottom: "30px" }}>
                      <div className="me-3">
                        <label htmlFor="billingType" className="form-label">
                          Billing Method{" "}
                          <span className="text-rgbr-red"> *</span>
                        </label>
                      </div>

                      <div>
                        <Controller
                          name="billingType"
                          defaultValue="BILLABLE"
                          control={control}
                          rules={{ required: "Billing Method is required" }} // Add validation rule
                          render={({ field }) => (
                            <RadioGroup
                              row
                              {...field}
                              onChange={(e) => field.onChange(e.target.value)} // Explicitly update value
                              value={field.value || ""} // Ensure value is handled
                            >
                              <FormControlLabel
                                value="BILLABLE"
                                control={<Radio />}
                                label="Billable"
                              />
                              <FormControlLabel
                                value="NON-BILLABLE"
                                control={<Radio />}
                                label="Non - Billable"
                              />
                            </RadioGroup>
                          )}
                        />
                      </div>
                      {/* Display error for Billing Method */}
                      {errors.billingType && (
                        <span className="errorMsg">
                          {errors.billingType.message}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="bg-white position-absolute w-100 bottom-0 py-3">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="add_btn me-3"
                    disabled={isSubmitting}
                  >

                    {isSubmitting ? (
                      <>
                        <BtnLoader />
                      </>
                    ) : (
                      // "Add "
                      isEdit ? "Update " : "Add "
                    )}
                  </button>

                  {!isEdit && (
                    <button
                      type="button"
                      className="addmore_btn me-3"
                      onClick={addMoreTasks}
                      disabled={isSubmitting}
                    >
                      Add more
                    </button>
                  )}
                  
                  <button
                    type="button"
                    className="cancel_btn"
                    disabled={isSubmitting}
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};
